import { createEaseAuthClient } from "@ease/auth/client";

// Auth traffic must terminate at auth.stero.ai in production. Falling back to VITE_API_URL
// silently misroutes Better Auth endpoints through api.stero.ai and produces 404s such as
// /auth/organization/members. Only local dev should use the same-origin Vite proxy path.
interface WindowLocationLike {
  location?: {
    hostname?: string;
  };
}

export function resolveAuthBaseUrlFromEnv(
  envAuthUrl: string | undefined,
  windowLike: WindowLocationLike | undefined,
): string {
  const trimmedEnvAuthUrl = envAuthUrl?.trim();
  if (trimmedEnvAuthUrl) {
    return trimmedEnvAuthUrl;
  }

  const hostname = windowLike?.location?.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1") {
    return "";
  }

  return "https://auth.stero.ai";
}

function resolveAuthBaseUrl(): string {
  const envAuthUrl = import.meta.env.VITE_AUTH_URL?.trim();
  if (envAuthUrl) {
    return envAuthUrl;
  }
  return resolveAuthBaseUrlFromEnv(undefined, typeof window !== "undefined" ? window : undefined);
}

const AUTH_URL = resolveAuthBaseUrl();

export const authClient = createEaseAuthClient({
  baseURL: AUTH_URL,
});

export type { AuthClient } from "@ease/auth/client";
